export default "__VITE_ASSET__HsDt1AdM__"